<p>user-profile-info-edit works!</p>
